import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import SFToggleButton from "../../../toggleButton";
import { SFAppsIcon } from "../../../icons";
import SFTooltip from "../../../tooltip";
import NavButtonMenu from "./navButtonMenu";
import getStyled from "../../../../hooks/getStyled";

const { styled } = getStyled();

const ToggleButtonStyled = styled(SFToggleButton)(({ theme }) => ({
  background: "radial-gradient(50% 50% at 50% 50%, #FFF 33.85%, #F0F2F5 100%)",
  border: `1px solid ${theme.palette.grey225.main}`,
  borderRadius: "4px",
  color: theme.palette.grey500.main,
  height: "35px",
  width: "35px",
  "& .MuiSvgIcon-root": {
    fontSize: "20px",
  },
  "&:hover": {
    background: "radial-gradient(50% 50% at 50% 50%, #FFF 0%, #EAF6FF 100%)",
    border: `1px solid ${theme.palette.blue300_1.main}`,
  },
  "&.Mui-selected": {
    background: "radial-gradient(50% 50% at 50% 50%, #FFF 0%, #EAF6FF 100%)",
    border: `1px solid ${theme.palette.blue300_1.main}`,
  },
}));

const NavButton = ({ navDefs = [], menuAnchorEl, selected, onClick }) => {
  const { t } = useTranslation();

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <SFTooltip
        placement="right"
        content={t("components.actionBar.tooltips.navButton")}
      >
        <ToggleButtonStyled
          onClick={() => {
            onClick();
            setMenuOpen((prev) => !prev);
          }}
          selected={selected}
        >
          <SFAppsIcon />
        </ToggleButtonStyled>
      </SFTooltip>
      <NavButtonMenu
        open={menuOpen}
        onClose={() => {
          onClick();
          setMenuOpen((prev) => !prev);
        }}
        anchorEl={menuAnchorEl}
        navDefs={navDefs}
      />
    </>
  );
};

NavButton.propTypes = {
  // The navigation definitions
  navDefs: PropTypes.arrayOf(
    PropTypes.shape({
      // The icon to display in the button
      icon: PropTypes.element,
      // The header text to display in the button
      header: PropTypes.string,
      // The description text to display in the button
      description: PropTypes.string,
      // The path to navigate to when the button is clicked
      path: PropTypes.string,
      // Whether the button is the default (renders a check icon)
      default: PropTypes.bool,
    })
  ),
  // The element to anchor the navigation menu to
  menuAnchorEl: PropTypes.object,
  // Whether the button is selected or not
  selected: PropTypes.bool,
  // The function to call when the button is clicked
  onClick: PropTypes.func,
};

export default NavButton;
